import { render, staticRenderFns } from "./RbCheckboxes.vue?vue&type=template&id=3bef14f8&"
import script from "./RbCheckboxes.vue?vue&type=script&lang=js&"
export * from "./RbCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./RbCheckboxes.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports